module.exports = __webpack_public_path__ + "img/orange_105.a21eabc2.png";